/** @file primaryPartsOf: one part per node of a rest placement (layered drawables share their node's). */
import type { PlacedPart } from './sheetTypes';

/** Larger tile area first, then nearer (smaller depth). */
const better = (a: PlacedPart, b: PlacedPart): boolean => {
  const area = a.size[0] * a.size[1] - b.size[0] * b.size[1];
  return area !== 0 ? area > 0 : a.depth < b.depth;
};

/**
 * The parts a sheet maps, far to near: of the drawables on one node (face, hair, hat on the head) the one with the
 * largest tile, the nearest on a tie, stands for the node; one painting of a head cannot be split into its layers.
 */
export function primaryPartsOf(parts: readonly PlacedPart[]): PlacedPart[] {
  const best = new Map<string, PlacedPart>();
  for (const p of parts) {
    const held = best.get(p.node);
    if (held === undefined || better(p, held)) best.set(p.node, p);
  }
  const kept = new Set(best.values());
  return parts.filter((p) => kept.has(p));
}
